export function convertMinutesToTime(minutes) {
  let hours = Math.floor(minutes / 60);
  let remainingMinutes = minutes % 60;
  return (
    hours +
    ':' +
    (remainingMinutes < 10 ? '0' : '') +
    remainingMinutes
  );
}
